class AmplifyInformationController {
  constructor(EventEmitter) {
    'ngInject';
    this.EventEmitter = EventEmitter;
  }

  onDismiss(){
    this.onClose(this.EventEmitter({state: false}));
  }
}

export default AmplifyInformationController;


// WEBPACK FOOTER //
// ./client/app/solidarity.module/components/amplifyInformation/amplifyInformation.controller.js